import { O } from '@utils/ts';

export const EMPTY_OBJECT = Object.freeze({}) as O.Object;
